import ValoresRepository from '@/services/ValoresRepository'
import Vue from 'vue'

export default {
  namespaced: true,
  state: {
    listaCuentasEntidad: [],
    listaPlazoFijoEntidad: [],
    listaPrestamosEntidad: [],
    listaFacturaCreditoResumen: [],
    listaEstudiantes: [],
    cotizacionMoneda: {},
    datosEntidad: {},
  },
  getters: {
    getSimboloMoneda: (state) => (idCuenta) => {
      if (state.listaCuentasEntidad.length > 0) {
        let cuenta = state.listaCuentasEntidad.find(cuenta => cuenta.idCuenta === idCuenta)

        return cuenta ? `(${cuenta.simboloMoneda})` : ''
      }

      return ''
    },
    getNombreCuenta: (state) => (idCuenta) => {
      if (state.listaCuentasEntidad.length > 0) {
        let cuenta = state.listaCuentasEntidad.find(cuenta => cuenta.idCuenta === idCuenta)

        return cuenta ? cuenta.nombreCuenta : ''
      }

      return ''
    },
    getCantidadDecimalesMoneda: (state) => (idCuenta) => {
      if (state.listaCuentasEntidad.length > 0) {
        let cuenta = state.listaCuentasEntidad.find(cuenta => cuenta.idCuenta === idCuenta)

        return cuenta ? cuenta.cantidadDecimalesMoneda : 0
      }

      return 0
    },
  },
  mutations: {
    setGeneral(state, general) {
      state.listaCuentasEntidad = general.listaCuentasEntidad.map(cuenta => {
        cuenta.cuentaFormated = Vue.filter('fhCuenta')(cuenta.idCuenta.toString())
        return cuenta
      })
      state.listaPlazoFijoEntidad = general.listaPlazoFijoEntidad
      state.listaPrestamosEntidad = general.listaPrestamosEntidad
      state.listaFacturaCreditoResumen = general.listaFacturaCreditoResumen
      let i = 0
      state.listaEstudiantes = general.listaEstudiantes.map(estudiante =>{
        let id = 0
        estudiante.becaMovimientos.map(movimiento =>{
          movimiento.id = id
          id++
          return movimiento
        })
        estudiante.id = i
        i++
        return estudiante
      })
      state.cotizacionMoneda = general.cotizacionMoneda
      state.datosEntidad = general.datosEntidad
    },
  },
  actions: {
    async fetchGeneral({state, commit}) {
      if (state.listaCuentasEntidad.length > 0) {
        return
      }

      let general = await ValoresRepository.general()
      commit('setGeneral', general)
    },
  }
}
